import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';

$(function () {
  let $imgs = $('.wysiwyg figure > img:not(.inline-video *)');
	const isOrg = !!document.querySelector(".page--ORG");
  if (!!$imgs.length && isOrg) {	
		const modal = document.createElement("div");
		modal.classList.add("image-modal");
		modal.setAttribute("aria-hidden", "true");
		const modalInner = document.createElement("div");
		modalInner.classList.add("image-modal__inner");
		const modalImg = document.createElement("img");
		modalImg.setAttribute("src", "");
		modalImg.setAttribute("alt", "");

		modalInner.insertAdjacentElement("afterbegin", modalImg);
		modal.insertAdjacentElement("afterbegin", modalInner);
		document.body.insertAdjacentElement("beforeend", modal);

		const openModal = (img, expand) => {
			modalImg.setAttribute("src", img.getAttribute("src"));
			if (!!img.getAttribute("alt")) modalImg.setAttribute("alt", img.getAttribute("alt"));
			modal.classList.add("is-active");
			if (!!expand) expand.setAttribute("data-modal-active", "true");
			modal.setAttribute("aria-hidden", "false");
			disableBodyScroll(modal);
			document.querySelector("html").style.overflow = "hidden";
		}

		const closeModal = () => {
			const expand = document.querySelector(".wysiwyg figure button[data-modal-active]") || false;
			modal.classList.remove("is-active");
			modal.setAttribute("aria-hidden", "true");
			if (!!expand) {
				expand.removeAttribute("data-modal-active");
				expand.focus();
			}
			enableBodyScroll(modal);
			document.querySelector("html").style.overflow = "";
		}

		modal.addEventListener("click", closeModal);
		document.body.addEventListener("keydown", e => {
			if (modal.matches(".is-active") && e.code == "Escape") closeModal();
		});

		[...$imgs].forEach(img => {
			const figure = img.closest("figure");
			const expand = document.createElement("button");
			expand.classList.add("img-expand");
			expand.setAttribute("aria-label", "Expand image full screen");
			let bottomToImage = figure.getBoundingClientRect().bottom - img.getBoundingClientRect().bottom;
			figure.insertAdjacentElement("beforeend", expand);
			expand.style.bottom = window.innerWidth < 767 ? `${bottomToImage + 8}px` : `${bottomToImage + 16}px`;

			expand.addEventListener("click", () => openModal(img, expand));
		});
  }
});
